module.exports = __webpack_public_path__ + "media/PsbottomlinePt1.acea7580.mp4";